export function validateURL(url: string | undefined) {
	if (!url) return false;

	try {
		const parsed = new URL(url);
		if (!['http:', 'https:'].includes(parsed.protocol)) return false;
		return true;
	} catch (err) {
		return false;
	}
}
